import { logNextNavigation } from '../../logger/navigationLogger';
import { scrollToFirstQuestionOfPage } from '../../utils';
import { pushPageHistory } from '../../utils/pageHistory';
import type { OnNextRunState } from './types';

/** Move the user to another content page and record it in navigation history. */
export function navigateToPage(run: OnNextRunState, targetPageIndex: number): void {
  logNextNavigation(run.currentPageIndex);
  pushPageHistory(run.refs, run.currentPageIndex, targetPageIndex);
  run.setCurrentPageIndex(targetPageIndex);
  run.setPhase({ kind: 'content', pageIndex: targetPageIndex });
  run.refs.visitedPageIndices.add(targetPageIndex);
  run.bumpProgressRevision();
  scrollToFirstQuestionOfPage(run.pages, targetPageIndex);
}
